// extracted by mini-css-extract-plugin
export default {"slowLoader":"SlowLoader_slowLoader__IFWcA","slowLoaderRotate":"SlowLoader_slowLoaderRotate__bRIya"};